import { render, staticRenderFns } from "./payFail.vue?vue&type=template&id=55ad94d0&scoped=true"
import script from "./payFail.vue?vue&type=script&lang=js"
export * from "./payFail.vue?vue&type=script&lang=js"
import style0 from "./payFail.vue?vue&type=style&index=0&id=55ad94d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ad94d0",
  null
  
)

export default component.exports